<template>
    <div class="header">
        <v-app-bar
                min-height="'137px'"
                color="white"
                clipped-right
                height="70"
                fixed
        >
            <!-- the sidebar is always open on desktop, so there is nothing to toggle -->
            <v-icon v-if="!isDesktop"
                    color="primary"
                    size="40"
                    @click="drawer = !drawer">fas fa-bars
            </v-icon>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
                <v-img
                        alt="mai"
                        class="shrink"
                        contain
                        :src="logoSrc"
                        transition="scale-transition"
                        width="40"
                />
            </div>
        </v-app-bar>
        <!-- Admins act across their whole organization and every write lands on
             a contractor's record, so the mode is always on screen. -->
        <div class="admin-strip" v-if="isAdmin">מצב מנהל</div>
        <!-- desktop: a permanent side menu. mobile: the full-screen drawer,
             unchanged. -->
        <v-navigation-drawer
                v-model="drawer"
                :permanent="isDesktop"
                :width="isDesktop ? 280 : '100%'"
                :right="isDesktop"
                :class="{'desktop-menu': isDesktop, 'below-admin-strip': isDesktop && isAdmin}"
                clipped
                absolute
                height="'539px'">
            <v-sheet v-if="!isDesktop"
                     color="primary"
                     tile
                     class="white--text ps-12 userData" height="70">שלום, {{userName}}
            </v-sheet>
            <!-- on desktop the greeting sits in the menu itself, since the bar
                 above it has no room for it -->
            <div v-else class="desktop-greeting">שלום, {{userName}}</div>
            <v-list class="px-4 py-0">
                <template v-for="(item,index) in visibleItems">
                    <v-divider v-if="item.divider" :key="index"></v-divider>
                    <v-list-item
                            v-else-if="item.routerLink"
                            class="ps-10 my-0 py-1"
                            color="primary"
                            :key="item.title"
                            tile
                            link
                            :to="item.url"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-img width="28" :src="getImageLink(item.icon)"></v-img>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                    <v-list-item
                            v-else
                            class="ps-10 my-0 py-1"
                            color="primary"
                            :key="item.title"
                            tile
                            link
                            :href="item.url"
                    >
                        <v-list-item-icon class="ml-7">
                            <v-img width="28" :src="getImageLink(item.icon)"></v-img>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>

    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "vHeader",
        data: () => {
            return {
                drawer: false,
                group: null,
                logoSrc: require(`@/assets/logo.svg`),
                items: [
                    {title: 'ראשי', icon: 'home-icon', url: '/', routerLink: true},
                    {divider: true, inset: true},
                    /* an admin's home already IS the requests list, so the
                       separate entry would just point at the same screen */
                    {title: 'קריאות תושבים', icon: 'id-icon', url: '/resident-requests', routerLink: true, contractorOnly: true},
                    {divider: true, inset: true, contractorOnly: true},
                    {title: 'צור קשר', icon: 'call-icon', url: 'tel:0775001090', routerLink: false},
                    {divider: true, inset: true},
                    {title: 'התנתק', icon: 'sign-out-icon', url: '/logout', routerLink: true},
                ]
            }
        },
        methods: {
            getImageLink: function getImageLink(icon) {
                return require(`@/assets/${icon}.svg`)
            }
        },
        computed: {
            ...mapState(['userName', 'isAdmin']),
            /* hide entries (and their dividers) that do not apply to this role */
            visibleItems() {
                return this.items.filter(item => !item.contractorOnly || !this.isAdmin);
            },
            /* md and up — phones and small tablets keep the drawer */
            isDesktop() {
                return this.$vuetify.breakpoint.mdAndUp;
            },
        },
        watch: {
            group() {
                this.drawer = false
            },
        },
    }
</script>

<style scoped lang="scss">
    .userData {
        font-size: 19px;
        font-weight: 500;
        text-align: right;
        color: #ffffff;
        display: flex;
        align-items: center;
    }

    aside {
        top: 70px !important;
    }

    /* Desktop side menu — pinned open on the right, because the app is Hebrew.
       `!important` throughout: v-navigation-drawer writes its own inline top and
       height, which otherwise win.

       Physical `right`/`border-left` rather than logical properties: index.html
       carries no dir attribute, so the document is LTR as far as CSS is
       concerned and inline-start would resolve to the wrong edge. RTL here comes
       from Vuetify's own classes, not from the document direction. */
    .desktop-menu {
        position: fixed !important;
        top: 70px !important;
        height: calc(100vh - 70px) !important;
        right: 0 !important;
        left: auto !important;
        z-index: 5;
        border-left: 1px solid #e0e0e0;
    }

    /* the admin strip sits between the app bar and the menu */
    .desktop-menu.below-admin-strip {
        top: 98px !important;
        height: calc(100vh - 98px) !important;
    }

    .desktop-greeting {
        padding: 18px 24px 12px;
        font-size: 17px;
        font-weight: 600;
        color: #333;
    }

    .admin-strip {
        position: fixed;
        top: 70px; /* directly under the fixed app bar */
        right: 0;
        left: 0;
        /* below the app bar and the drawer, above ordinary page content */
        z-index: 4;
        height: 28px;
        background: $primary_color;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.5px;
    }
</style>
